module.exports = __webpack_public_path__ + "static/media/01(1).7bb08202.jpg";